import { ShieldCheck } from "lucide-react";
import { SAFETY_POINTS } from "@/data/content";
import { useSite } from "@/context/SiteContext";
import Snippet from "@/components/Snippet";

export default function SafetyNote({ className = "" }) {
  const { snip } = useSite();
  return (
    <div
      className={`rounded-3xl border border-brand-line bg-brand-lavender-soft/50 p-8 md:p-10 ${className}`}
      data-testid="safety-note"
    >
      <div className="flex items-center gap-3 mb-5">
        <ShieldCheck className="text-brand-forest" strokeWidth={1.5} />
        <h3 className="font-heading text-2xl text-brand-ink">
          <Snippet k="safety.heading" fallback="Your safety & wellbeing" />
        </h3>
      </div>
      <ul className="space-y-3">
        {[1, 2, 3, 4, 5, 6].map((n, i) => {
          const val = snip(`safety.point${n}`, SAFETY_POINTS[i] || "");
          if (!val) return null;
          return (
            <li key={n} className="flex gap-3 font-body text-sm text-brand-slate leading-relaxed">
              <span className="mt-2 h-1.5 w-1.5 rounded-full bg-brand-lavender shrink-0" />
              <Snippet k={`safety.point${n}`} fallback={SAFETY_POINTS[i] || ""} />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
